export const setValueInRange = (value, minValue, maxValue) => Math.min(Math.max(value, minValue), maxValue);

export const isEven = value => value % 2 === 0;

export const onlyNumbers = str => str.match(/\d+/g)?.join('') || '';

export const convertDecimal = (value, radix) => Number(value).toString(radix);
